import { notification, Space, Popover } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../components/Modals/DeleteModal";
import GenericModal from "../../components/Modals/GenericModal";
import ShareModal from "../../components/Modals/ShareModal";
import QuizModal from "../../components/pages/Quizzes/QuizModal/QuizModal";
import { Assets } from "../../constants/images";
import {
  EditIcon,
  PurpleBackIcon,
  RecycleBin,
  ShareIcon,
  ToastCrossIcon,
} from "../../constants/svg";
import { DeleteQuiz, GetQuizByID, sortQuizQuestions } from "../../services/quiz/quiz";
import { setStatUserHover } from "../../store/slices/globalSlice";
import {
  setActionButtonDisable,
  setPageLoading,
  setQuizAddEditForm,
  setSelectedData,
} from "../../store/slices/quizSlice";
import ProfileHoverChat from "../../components/Common/ProfileHoverChat";
import {
  hasAccess,
  renderContentWithLinks,
  toastMessage,
} from "../../utils/helper";
import TrueFalseView from "../../components/Common/TrueFalseQuetionView";
import MultipleChoiceQuestionView from "../../components/Common/MultipleChoiceQuestionView";
import PictureQuestionView from "../../components/Common/PictureQuestionView";
import { salonQuestionType, SHARE_URL } from "../../utils/constants";
import { formatQuizScore } from "../../utils/quizScore";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import ProfileHover from "../../components/Common/ProfileHover";
import AvatarImage from "../../components/Common/AvatarImage";

const QuizDetail = () => {
  const { positions } = useSelector((state) => state.global);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    selectedData,
    pageLoading,
    actionButtonDisable,
    reRenderQuizDetailPage,
    quizAddEditForm,
  } = useSelector((state) => state.quiz);
  const { statUserHover } = useSelector((state) => state.global);

  const { id } = useParams();

  const [showModal, setShowModal] = useState({
    shareModal: null,
    editModal: null,
    deleteModal: null,
  });
  const [open, setOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [show, setShow] = useState(null);

  const handleMouseEnter = (item) => {
    setHoveredItem(item.user?.id);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
    setShow(false);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onDeleteQuiz = async () => {
    try {
      dispatch(setActionButtonDisable(true));
      const resp = await DeleteQuiz(id);
      const { data, message, status } = resp.data;
      if (!status) {
        notification.error({
          description: message,
          placement: "bottomRight",
          className: "createdNotification",
          closeIcon: <ToastCrossIcon />,
        });
        return;
      }
      setShowModal({ ...showModal, deleteModal: false });
      navigate("/quizzes");
      toastMessage("delete", message);
    } catch (e) {
      toastMessage("error", e.message);
    } finally {
      dispatch(setActionButtonDisable(false));
    }
  };

  const getSingleQuizByID = async () => {
    dispatch(setPageLoading(true));
    const response = await GetQuizByID(id);
    const { data, message, status } = response.data;
    if (!status) {
      notification.error({
        description: message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
      return;
    }
    dispatch(setPageLoading(false));
    dispatch(setSelectedData(data));
  };

  useEffect(() => {
    getSingleQuizByID();
  }, [reRenderQuizDetailPage]);

  if (pageLoading || !selectedData) {
    return <LoadingScreen child={true} />;
  }

  const orderedQuizQuestions = sortQuizQuestions(selectedData?.quizQuestions);

  const returnPosition = (position_id) => {
    if (positions) {
      for (let i = 0; i < positions?.length; i++) {
        if (positions[i]?.value == position_id) {
          return positions[i]?.label || "-";
        }
      }
    }
  };

  const renderQuizResultUser = (elem, index, tone) => {
    if (!elem?.user?.name) return null;
    const scoreLabel = tone ? formatQuizScore(elem.score) : null;
    return (
      <div
        key={elem.id ?? `${tone || "pending"}-${elem.user.id}-${index}`}
        style={{ position: "relative" }}
        className="avatar-item quiz-score-row"
      >
        <Popover
          placement="rightTop"
          content={
            <ProfileHover
              user={{
                id: elem?.user?.id,
                name: elem?.user?.name,
                image: elem?.user?.image,
                position: returnPosition(elem?.user?.position_id),
              }}
            />
          }
          arrow={true}
        >
          <div className="statUserHoverContainer customHover">
            <AvatarImage
              name={elem?.user?.name}
              src={elem?.user?.image}
              placeholder={Assets.ProfilePlaceholder}
              size={38}
            />
          </div>
        </Popover>
        <NavLink
          className="quiz-result-name"
          title={elem.user.name}
          to={`/team/members/${elem?.user?.slug ?? elem?.user?.id}`}
        >
          <p>{elem.user.name}</p>
        </NavLink>
        {scoreLabel ? (
          <span className={`quiz-score-pill quiz-score-pill--${tone}`}>
            {scoreLabel}
          </span>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <Row>
        <Col lg={9} className={"pe-0"}>
          <div className="leftEventDetailWrapper">
            <div className="eventDetailHeader innerContainer d-flex justify-content-between">
              <div className="backToEvent">
                <NavLink to="/quizzes">
                  <PurpleBackIcon />
                  <span className="uLineHover">Back to Quizzes</span>
                </NavLink>
              </div>
              <div className="shareButton">
                <Space size={"large"}>
                  {/* <div
                    className="icon-text-wrapper cursor-pointer blackLine"
                    onClick={() => {
                      navigate('/quiz/quizbuilder/' + id)
                    }}
                  >
                    <p className="uLine ">Quiz Builder</p>
                  </div> */}
                  <div
                    className="icon-text-wrapper cursor-pointer blackLine"
                    onClick={() =>
                      setShowModal((prevState) => ({
                        ...prevState,
                        shareModal: true,
                      }))
                    }
                  >
                    <ShareIcon />
                    <p className="uLine ">Share</p>
                  </div>
                  {hasAccess(selectedData?.user) && (
                    <div
                      className="icon-text-wrapper cursor-pointer blackLine"
                      onClick={() => {
                        dispatch(
                          setQuizAddEditForm({
                            show: true,
                            formType: "update",
                          }),
                        );
                      }}
                    >
                      <EditIcon />
                      <p className="uLine ">Edit</p>
                    </div>
                  )}
                  {hasAccess(selectedData?.user) && (
                    <div className="icon-text-wrapper deleteLabel cursor-pointer">
                      <RecycleBin />
                      <p
                        className="uLine redLine"
                        onClick={() =>
                          setShowModal((prevState) => ({
                            ...prevState,
                            deleteModal: true,
                          }))
                        }
                      >
                        Delete
                      </p>
                    </div>
                  )}
                </Space>
              </div>
            </div>
            <div className="eventDetailBody">
              <div className="innerContainer">
                <h3 className="sec-heading">{selectedData?.name || "-"}</h3>
                <div className="eventDetailInformation">
                  <div className="eventDetailItem">
                    <h5 className="head">Category</h5>
                    <p>{selectedData?.category.name || "-"}</p>
                  </div>
                  <div className="eventDetailItem">
                    <h5 className="head">Tags</h5>
                    <p>
                      {selectedData?.tags?.length
                        ? selectedData.tags.map((elem) => elem.name).join(", ")
                        : "-"}
                    </p>
                  </div>
                  <div className="eventDetailItem">
                    <h5 className="head">Description</h5>
                    <p>
                      {selectedData?.description
                        ? renderContentWithLinks(selectedData?.description)
                        : "-"}
                    </p>
                  </div>
                  <div className="eventDetailItem">
                    <h5 className="head">Created By</h5>
                    <p>{selectedData?.user?.name || "-"}</p>
                  </div>
                  <div className="eventDetailItem">
                    <h5 className="head">Created On</h5>
                    <p>
                      {selectedData &&
                        moment(selectedData?.created_at).format("MMM DD, YYYY")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="outerContainer">
                <div className="survey-container">
                  <div className="survey-border-wrapper">
                    {orderedQuizQuestions.map((elem, index) => {
                      if (elem.type == salonQuestionType.BOOL) {
                        return (
                          <TrueFalseView
                            data={elem}
                            index={index}
                            assignedUsers={selectedData?.userQuizScore}
                            detailPageType="quiz"
                          />
                        );
                      }

                      if (elem.type == salonQuestionType.MULTIPLE) {
                        return (
                          <MultipleChoiceQuestionView
                            data={elem}
                            index={index}
                            assignedUsers={selectedData?.userQuizScore}
                            detailPageType="quiz"
                          />
                        );
                      }

                      if (elem.type == salonQuestionType.PICTURE) {
                        return (
                          <PictureQuestionView
                            data={elem}
                            index={index}
                            assignedUsers={selectedData?.userQuizScore}
                            detailPageType="quiz"
                          />
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>

        <Col lg={3} className={"p-0"} onMouseLeave={handleMouseLeave}>
          <div className="rightEventDetailWrapper">
            <div className="eventDetailHeader d-flex justify-content-between">
              <h4 className="sec-heading m-0 p-0">Quiz Results</h4>
            </div>
            <div className="eventDetailBody quiz-results">
              <div className="response-card">
                <div className="response-header">
                  <h6>High Score ({selectedData?.hightScoreUser?.length})</h6>
                </div>
                <div className="response-body">
                  {selectedData?.hightScoreUser?.map((elem, index) =>
                    renderQuizResultUser(elem, index, "high"),
                  )}
                </div>
              </div>
              <div className="response-card">
                <div className="response-header">
                  <h6>Low Score ({selectedData?.lowScoreUser?.length})</h6>
                </div>
                <div className="response-body">
                  {selectedData?.lowScoreUser?.map((elem, index) =>
                    renderQuizResultUser(elem, index, "low"),
                  )}
                </div>
              </div>
              <div className="response-card">
                <div className="response-header">
                  <h6>Not Started ({selectedData?.notStartedUser?.length})</h6>
                </div>
                <div className="response-body">
                  {selectedData?.notStartedUser?.map((elem, index) =>
                    renderQuizResultUser(elem, index, null),
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Share Modal */}
          <ShareModal
            show={showModal.shareModal}
            onHide={() =>
              setShowModal((prevState) => ({ ...prevState, shareModal: false }))
            }
            setModalShow={() =>
              setShowModal((prevState) => ({ ...prevState, shareModal: true }))
            }
            modalTitle={"Share Quiz"}
            shareLink={SHARE_URL.QUIZZES + selectedData?.id}
            data={{
              image: selectedData?.image,
              name: selectedData?.name,
              description: selectedData?.description,
              start_date: selectedData
                ? moment(selectedData.created_at).format("MMM DD, yyyy")
                : "",
              start_time: selectedData
                ? moment(selectedData.created_at).format("hh:mm a")
                : "",
            }}
            modalSubtitle={
              <>
                Click “Copy Link” below, then
                <NavLink
                  to="/inbox"
                  className={"uLine blue-accent-color"}
                  target="_blank"
                >
                  &nbsp;Open Chat&nbsp;
                </NavLink>
                to easily share this quiz with members.
              </>
            }
            size={"lg"}
            bodyComponent={{
              img: Assets.eventShareModal,
              title: "Matrix Hair Coloring Quiz",
              para1:
                "This is event dummy message will replace with the. This is event dummy message will replace with the. This is event dummy message will replace with the...",
              para2: "8 Questions • Oct 04, 2023",
            }}
          />

          {/* Delete Modal */}
          <DeleteModal
            disable={actionButtonDisable}
            handleDelete={onDeleteQuiz}
            show={showModal.deleteModal}
            onHide={() => setShowModal({ ...showModal, deleteModal: false })}
            heading="Delete Quiz?"
            para={
              <>
                Are you sure you want to delete <b>{selectedData?.name}?</b>
                <br />
                Important: This quiz cannot be recovered.
              </>
            }
            notificationMessage="Quiz"
          />
        </Col>
      </Row>

      <GenericModal
        show={quizAddEditForm.show}
        onHide={() => {
          dispatch(
            setQuizAddEditForm({
              show: false,
              formType: null,
            }),
          );
        }}
        setModalShow={(e) => {
          dispatch(
            setQuizAddEditForm({
              show: false,
              formType: null,
            }),
          );
        }}
        modalTitle={
          quizAddEditForm.formType == "create" ? "Create New Quiz" : "Edit Quiz"
        }
        size={"lg"}
        bodyComponent={<QuizModal />}
      />
    </>
  );
};

export default QuizDetail;
